import { Dispatch, SetStateAction, useEffect, useMemo, useState } from "react"
import { v4 as uuidv4 } from 'uuid'
import {
  UnitSectorTable,
  UnitSectorTHead,
  UnitSectorTr,
  UnitSectorTh,
  UnitSectorTbody,
  UnitSectorTbodyTr,
  UnitSectorTbodyTd,
  AddFields,
  trashComponent
} from 'pages/Configurations/FormUser/styles'
import { TableContainer } from "components/SharedTable/styles"
import { InputSelect } from "components/InputSelect"
import { Control, FieldValues, UseFieldArrayAppend, UseFieldArrayRemove, UseFormGetValues, UseFormSetValue, UseFormWatch } from "react-hook-form"
import { ILocationReducer } from "types/location"
import { ISectorReducer } from "types/sector"
import { BsPlusLg, BsTrash } from "react-icons/bs"
import { IFormLocation } from "."

export interface UnitySectorTable {
  watch: UseFormWatch<FieldValues>
  profileShouldHaveUnity: () => boolean
  profileShouldHaveSector: () => boolean
  fields: Record<"id", string>[]
  setFocusedSectorOrUnit: Dispatch<SetStateAction<string>>
  focusedSectorOrUnity: string
  errorFields: any[]
  currentSelectedUserState: any
  control: Control<FieldValues, any>
  locationSelector: ILocationReducer
  setValue: UseFormSetValue<FieldValues>
  sectorSelector: ISectorReducer,
  append: UseFieldArrayAppend<FieldValues, "fields">
  remove: UseFieldArrayRemove
  getValues: UseFormGetValues<FieldValues>
  formLocations: IFormLocation[]
}
export const UnitySectorTable = ({
  watch,
  getValues,
  remove,
  append,
  control,
  profileShouldHaveUnity,
  profileShouldHaveSector,
  fields,
  setFocusedSectorOrUnit,
  focusedSectorOrUnity,
  errorFields,
  currentSelectedUserState,
  locationSelector,
  setValue,
  sectorSelector,
  formLocations
}: UnitySectorTable) => {

  const selectAll = ({ name, options, isAllSelected }: { name: string, options: any[], isAllSelected: boolean }) => {
    if (isAllSelected) {
      setValue(name, [])
    } else {
      const values = options?.map(option => (option.value))
      setValue(name, values)
    }
  }

  const addField = () => {
    if (getValues('fields')?.filter(f => f.unity)?.length === getValues('fields')?.length) {
      append({
        id: uuidv4(),
      })
    }
  }

  const removeField = (index: number) => {
    const rows = getValues('fields')
    remove(index)

  }

  return (
    <div className='mb-8'>
      {
        profileShouldHaveUnity() || profileShouldHaveSector() ?
          <>
            <TableContainer data-testid="test-unit-sector-component" className={`${profileShouldHaveSector() ? 'max-w-[720px]' : 'max-w-[360px]'}`}>
              <UnitSectorTable>
                <UnitSectorTHead>
                  <UnitSectorTr>
                    {
                      profileShouldHaveUnity() ?
                        <UnitSectorTh scope='col'>
                          <p className="font-bold text-base text-blueTheme">
                            Unidade
                          </p>
                        </UnitSectorTh>
                        : null
                    }
                    {
                      profileShouldHaveSector() ?
                        <UnitSectorTh>
                          <p className="font-bold text-base text-blueTheme">
                            Setor
                          </p>
                        </UnitSectorTh>
                        : null
                    }
                  </UnitSectorTr>
                </UnitSectorTHead>
                <UnitSectorTbody data-testid="test-action-table-body">
                  {
                    fields?.map((field, index) => {
                      return (
                        <SelectOptions
                          setValue={setValue}
                          formLocations={formLocations}
                          key={field.id}
                          watch={watch}
                          removeField={removeField}
                          selectAll={selectAll}
                          control={control}
                          profileShouldHaveUnity={profileShouldHaveUnity}
                          profileShouldHaveSector={profileShouldHaveSector}
                          fields={fields}
                          field={field}
                          setFocusedSectorOrUnit={setFocusedSectorOrUnit}
                          focusedSectorOrUnity={focusedSectorOrUnity}
                          errorFields={errorFields}
                          currentSelectedUserState={currentSelectedUserState}
                          locationSelector={locationSelector}
                          sectorSelector={sectorSelector}
                          index={index}
                          getValues={getValues}
                        />
                      )
                    })
                  }
                </UnitSectorTbody>
              </UnitSectorTable>
            </TableContainer>
            <AddFields
              className={`${false
                ? 'text-mediumGray border-mediumGray'
                : 'text-amberAlt'
                }`}
              data-testid="test-add-line-button"
              type="button"
              onClick={() => {
                addField()
              }}
            >
              <BsPlusLg
                className={`${false ? 'text-mediumGray' : 'text-amberAlt'
                  }`}
                size={8}
              />
              Adicionar linha
            </AddFields>
          </>
          : null
      }
    </div>
  )
}

export interface ISelectOptionsProps {
  setValue: UseFormSetValue<FieldValues>
  formLocations: IFormLocation[]
  watch: UseFormWatch<FieldValues>
  profileShouldHaveUnity: () => boolean
  profileShouldHaveSector: () => boolean
  fields: Record<"id", string>[]
  field: Record<"id", string>
  setFocusedSectorOrUnit: Dispatch<SetStateAction<string>>
  focusedSectorOrUnity: string
  errorFields: any[]
  currentSelectedUserState: any
  control: Control<FieldValues, any>
  locationSelector: ILocationReducer
  sectorSelector: ISectorReducer,
  index: number
  selectAll: ({ name, options, isAllSelected }: {
    name: string;
    options: any[];
    isAllSelected: boolean;
  }) => void,
  getValues?: UseFormGetValues<FieldValues>
  removeField: (index: number) => void
}

export const SelectOptions = ({
  removeField,
  selectAll,
  control,
  profileShouldHaveUnity,
  profileShouldHaveSector,
  fields,
  field,
  watch,
  setFocusedSectorOrUnit,
  focusedSectorOrUnity,
  errorFields,
  currentSelectedUserState,
  locationSelector,
  sectorSelector,
  index,
  formLocations,
  setValue,
  getValues
}: ISelectOptionsProps) => {
  const [sectorDidMount, setSectorDidMount] = useState(false)
  const unitIdValue = watch(`fields[${index}].unity`)

  const localSelector = useMemo(() => {
    return locationSelector?.locationsList
      ?.map((l) => ({
        value: l.sys_id,
        label: l.name
      }))
      .sort((o1, o2) =>
        o1.label.localeCompare(o2.label)
      )
  }, [locationSelector?.locationsList])

  const sectorSelect = useMemo(() => {
    return sectorSelector?.sectorsGroupedByLocationId?.[unitIdValue]
      ?.map((l) => ({
        value: l.sys_id,
        label: l.u_name
      }))
      .sort((o1, o2) =>
        o1.label.localeCompare(o2.label)
      )
  }, [unitIdValue, sectorSelector?.sectorsGroupedByLocationId])

  const onMountSector = () => {
    setSectorDidMount(true)
  }

  const canSelect = (a: any) => {
    return getValues(`fields`)?.map(f => f.unity).includes(a)
  }

  const onChange = (a: any) => {
    if (profileShouldHaveUnity() && !profileShouldHaveSector()) {
      if (!getValues(`fields`)?.map(f => f.unity).includes(a)) {
        setValue(`fields[${index}].unity`, a)
      }
    } else {
      setValue(`fields[${index}].unity`, a)
    }
  }

  useEffect(() => {
    if (formLocations?.[index]?.sector && sectorSelect && sectorDidMount) {
      setValue(`fields[${index}].sector`, formLocations[index].sector)
    }
  }, [sectorDidMount, formLocations, sectorSelect, setValue, index])

  return (
    <UnitSectorTbodyTr data-testid="test-table-rows">
      {
        profileShouldHaveUnity() ?
          <UnitSectorTbodyTd
            onFocus={(e) => {
              if (!errorFields.includes("name")) {
                setFocusedSectorOrUnit(`fields[${index}].unity`)
              } else {
                setFocusedSectorOrUnit(``)
              }

            }}
            onBlur={(e) => {
              if (!errorFields.includes("name")) {
                setFocusedSectorOrUnit(``)
              }
            }}
          >
            <div className={`${focusedSectorOrUnity === `fields[${index}].unity` ?
              `border-blueTheme rounded-b-lg border-2`
              : ''}`}>
              <InputSelect
                canSelect={canSelect}
                onChange={onChange}
                searchPlaceHolder="Buscar"
                shouldHaveSearch={true}
                styleContainer="border-none"
                name={`fields[${index}].unity`}
                required={true}
                control={control}
                errorStyle={`${errorFields?.includes(`fields[${index}].unity`) ? 'border  border-errorText' : ''
                  }`}
                data={localSelector}
                placeholder="Selecionar"
              />
            </div>
          </UnitSectorTbodyTd> : null
      }
      <UnitSectorTbodyTd
        data-testId="test-sector-select"
        onFocus={(e) => {
          if (!errorFields.includes("name")) {
            setFocusedSectorOrUnit(`fields[${index}].sector`)
          } else {
            setFocusedSectorOrUnit(``)
          }
        }}
        onBlur={(e) => {
          if (!errorFields.includes("name")) {
            setFocusedSectorOrUnit(``)
          }
        }}
      >
        {
          profileShouldHaveSector() ?
            <div className={`${focusedSectorOrUnity === `fields[${index}].sector` ?
              `border-blueTheme rounded-b-lg border-2`
              : ''}`}>
              <InputSelect
                onMount={onMountSector}
                searchPlaceHolder="Buscar"
                multiUnitText="Setores"
                selectAll={selectAll}
                allIsSelected={false}
                unitText="Setor"
                multiple={true}
                shouldHaveSearch={true}
                styleContainer="border-none"
                name={`fields[${index}].sector`}
                required={true}
                control={control}
                errorStyle={`${errorFields.includes(`fields[${index}].sector`) ? 'border border-errorText' : ''
                  }`}
                data={sectorSelect}
                placeholder="Selecionar"
              />

            </div>
            : null
        }
        {
          fields.length >= 2 ?
            <div
              onClick={() => {
                removeField(index)
              }}
              data-testid="test-delete-action-trash"
            >
              <BsTrash
                className={`${trashComponent}`}
                size={24}
              />
            </div>
            : null
        }
      </UnitSectorTbodyTd>

    </UnitSectorTbodyTr>
  )
}